export const API_EXTERNAL_ENDPOINT = 'bookmarks/lists'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/bookmarks/lists'
